import { z } from "zod";
import { environmentSchema, workflowContextSchema } from "./context.js";
import { nfeMoneySchema } from "./nfe-observations.js";
/** Records external process evidence; it neither requests a refund nor certifies entitlement. */
export const stRecoveryStatusSchema = z.enum(["POTENTIAL", "REQUESTED", "APPROVED", "REALIZED"]);
export const stRecoveryEvidenceSchema = z
    .object({
    evidenceId: z.string().uuid(),
    checksumSha256: z.string().regex(/^[a-f0-9]{64}$/),
    reference: z.string().trim().min(1).max(160),
})
    .strict();
const quantitySchema = z.string().regex(/^(0|[1-9]\d{0,10})(\.\d{1,4})?$/);
export const stRecoveryInvoiceItemSchema = z
    .object({
    evidenceId: z.string().uuid(),
    checksumSha256: stRecoveryEvidenceSchema.shape.checksumSha256,
    itemNumber: z.number().int().min(1).max(990),
    quantity: quantitySchema,
    commercialUnit: z.string().trim().min(1).max(40),
})
    .strict();
export const stRecoveryDeclarationSchema = z
    .object({
    productReference: z.string().trim().min(1).max(160),
    purchase: stRecoveryInvoiceItemSchema.extend({ retainedStAmount: nfeMoneySchema }).strict(),
    sale: stRecoveryInvoiceItemSchema,
    allocatedQuantity: quantitySchema,
    potentialAmount: nfeMoneySchema,
})
    .strict();
const commandBase = z
    .object({
    commandId: z.string().uuid(),
    caseId: z.string().uuid(),
    context: workflowContextSchema,
    actorId: z.string().min(1).max(128),
    recordedAt: z.string().datetime(),
    expectedVersion: z.number().int().min(0).max(5_000),
})
    .strict();
export const stRecoveryCommandSchema = z.discriminatedUnion("type", [
    commandBase
        .extend({ type: z.literal("REGISTER_POTENTIAL"), declaration: stRecoveryDeclarationSchema })
        .strict(),
    commandBase
        .extend({
        type: z.literal("RECORD_REQUEST"),
        amount: nfeMoneySchema,
        evidence: stRecoveryEvidenceSchema,
    })
        .strict(),
    commandBase
        .extend({
        type: z.literal("RECORD_APPROVAL"),
        amount: nfeMoneySchema,
        evidence: stRecoveryEvidenceSchema,
    })
        .strict(),
    commandBase
        .extend({
        type: z.literal("RECORD_REALIZATION"),
        amount: nfeMoneySchema,
        method: z.enum(["CASH_REFUND", "BOOK_CREDIT"]),
        evidence: stRecoveryEvidenceSchema,
    })
        .strict(),
]);
export const stRecoveryLedgerSchema = z
    .object({
    schemaVersion: z.literal("1.0.0"),
    organizationId: z.string().uuid(),
    environment: environmentSchema,
    events: z.array(stRecoveryCommandSchema).max(5_000),
})
    .strict();
//# sourceMappingURL=st-recovery-cases.js.map